module.exports = __webpack_public_path__ + "static/Newspaper-e0bd5bf53429935a2c285642da3da7a7.jpg";